import {
  EventType,
  InteractionType,
  type EventMessage,
} from '@azure/msal-browser';

type Listener = () => void;

let redirectAuthError: Error | null = null;
const listeners = new Set<Listener>();

const notify = () => {
  listeners.forEach((listener) => listener());
};

export const getRedirectAuthError = () => redirectAuthError;

export const subscribeToRedirectAuthError = (listener: Listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const setRedirectAuthError = (error: unknown) => {
  redirectAuthError =
    error instanceof Error
      ? error
      : new Error('The authentication redirect could not be completed.');
  notify();
};

export const clearRedirectAuthError = () => {
  if (!redirectAuthError) {
    return;
  }

  redirectAuthError = null;
  notify();
};

export const handleRedirectAuthEvent = (event: EventMessage) => {
  if (event.interactionType !== InteractionType.Redirect) {
    return;
  }

  if (
    event.eventType === EventType.LOGIN_FAILURE ||
    event.eventType === EventType.ACQUIRE_TOKEN_FAILURE
  ) {
    setRedirectAuthError(event.error);
    return;
  }

  if (
    event.eventType === EventType.LOGIN_SUCCESS ||
    event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS
  ) {
    clearRedirectAuthError();
  }
};

export const shouldStartInteractiveLogin = ({
  accountCount,
  isInteractionIdle,
  loginStarted,
  redirectError,
}: {
  accountCount: number;
  isInteractionIdle: boolean;
  loginStarted: boolean;
  redirectError: Error | null;
}) =>
  accountCount === 0 &&
  isInteractionIdle &&
  !loginStarted &&
  !redirectError;
